import config from "../config"
const baseUrl = config.base_url + "container_phenology_monitor_indicator/"
export default {
    listByMonitor: {
        url: baseUrl + "list_by_monitor",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    }
} 